import React from 'react'
import NewCommonServiceContent from '../../../common/NewCommonServices/NewCommonServiceContent'
import img from "../../../../assets/images/serviceImages/MobileAppWork.webp"

const MobileAppDevelopmentWork = () => {
  return (
    <div>
      <NewCommonServiceContent>
        <div className='rounded-[16px] w-full'>
          <img className='w-full h-[280px] sm:h-auto rounded-[16px] object-cover object-left' alt='' src={ img}/>
        </div>
      </NewCommonServiceContent>
    </div>
  )
}

export default MobileAppDevelopmentWork